import { render } from "./GTProjectList.vue?vue&type=template&id=e79e1e22&scoped=true"
import script from "./GTProjectList.vue?vue&type=script&lang=js"
export * from "./GTProjectList.vue?vue&type=script&lang=js"

import "./GTProjectList.vue?vue&type=style&index=0&id=e79e1e22&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e79e1e22"

export default script